import {gql} from 'apollo-angular';

export const GET_ALL_JOB_REQUIREMENT_TYPES = gql`
  query GetAllJobRequirementTypes {
    jobRequirementTypes{
      requirementTypes{
        requirementType{
          id,
          bicID,
          typeName
        },
        requirements {
          id,
          bicID,
          requirementName,
          description
        }
      }
    }
  }
`;
